<template>
  <v-row class="intro">
    <v-col lg="10" md="10" sm="10" offset-lg="1" offset-md="1" offset-sm="1">
      <h1>
        ORDER DIRECTLY FROM RUFF TUFF
      </h1>
      <div class="d-none d-sm-block d-md-block d-lg-block d-xl-block">
        <p style="text-align: center;">
          For ordering help, please call Ruff Tuff at 801-972-5845. (In the US only, call toll-free: 800-453-8830.)
        </p>
        <p style="text-align: center;"><strong>Online ordering is available only for orders shipping to US addresses.</strong></p>
        <p style="text-align: center;">To ship to addresses in <strong>Canada</strong>, please call Ruff Tuff at 801-972-5845.<br>All orders shipping to Canada are subject to a 25% tariff.</p>
        <p style="text-align: center;" class="bold"><em>Please use our Next and Back ( &lt; ) buttons, not your browser's.</em></p>
      </div>
     <!--  <v-alert
      color="primary"
      dark
      icon="mdi-firework"
      dense
      v-if="promo"
    >
      {{promo[0].promoText}}
    </v-alert> -->
  </v-col>
</v-row>
</template>

<style lang="scss">
.intro {
  background-color: #F3F3F3;
}

.intro h1 {
  font-family: $heading-font-family;
  text-transform: uppercase;
  text-align: center;
  margin: 10px 0;
  padding-left: 30px;
  padding-right: 30px;
  font-weight: 600;
  font-size: 1.8rem;

  @media screen and (min-width: 600px) {
    font-size: 3rem;
    padding-left: 0;
    padding-right: 0;
    margin: 50px 0 30px;
  }
}

p {
  font-family: $body-font-family;
  font-weight: 300;
  padding-left: 30px;
  padding-right: 30px;

  @media screen and (min-width: 600px) {
    padding-left: 0;
    padding-right: 0;
  }

  &.bold {
    font-weight: 600;
  }

  &.small {
    font-size: 0.875rem;
    font-style: italic;
  }
}
</style>

<script>
  import Promo from '../services/promo'

  export default {
    name: 'Intro',
    data() {
      return {
        promo: ''
      }
    },
    methods: {
      async getPromo() {
        this.promo = await Promo.get()
      },
    },
    mounted() {
      // this.getPromo()
    }
  }
</script>

